export const portalEnv = {
  ...process.env,
  ...((window as any).gymflow_env_config as {
    API_RESOLVER_URL: string;
    SENTRY_ENABLED: boolean;
    SENTRY_ENV: string;
    SENTRY_DSN: string;
    FULLCALENDAR_LICENSE: string;
  }),
};
